<template>
  <div class="song p-3 m-1">
    <h4>{{song.title}}</h4>
    <div v-if="isAdmin" class="btn-group">
      <button title="Modifier" class="btn btn-primary" @click="$router.push(`/edit-song/${encodeURIComponent(song.id)}`)">
        <i class="fa fa-edit"></i>
      </button>
      <button title="Supprimer" class="btn btn-danger" :class="{expanded: isDeleteSongRequested}" @click="deleteSong()" @blur="isDeleteSongRequested = false">
        <i class="fa fa-trash"></i>
        <span class="delete-text">Supprimer</span>
      </button>
    </div>
    <div class="metadata p-1 text-secondary">
      <div v-if="song.author">Autheur(s) : {{ song.author }}</div>
      <div v-if="song.date">Date d'ajout: {{ humanizeDate(song.date) }}</div>
    </div>
    <div class="btn-group btn-group-vertical mt-1" role="group">
      <SongCardButton v-if="song.files.mp3" text="Play" btn-class="btn-secondary" icon-class="fa-play" @click="playSong(song)" />
      <SongCardButton v-if="song.files.chopro" text="ChordPro" btn-class="btn-primary" icon-class="fa-file" @click="downloadFile(`${song.id}/${song.files.chopro.name}`, song.title)" />
      <SongCardButton v-if="song.files.pdf" text="PDF" btn-class="btn-dark" icon-class="fa-file-pdf" @click="downloadFile(`${song.id}/${song.files.pdf.name}`, song.title)" />
      <SongCardButton v-if="song.files.txt" text="Copier Paroles" btn-class="btn-secondary" icon-class="fa-copy" @click="copyTextInClipboard(song.lyrics)" />
    </div>    
  </div>
</template>

<style>
.song {
  border-radius: 5px;
  background: rgba(240, 240, 240, 0.7);
}
.btn-danger {
}
.delete-text {
  transition: all 0.3s ease;
  opacity: 0;
  max-width: 0;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0;
}
.expanded .delete-text {
  opacity: 1;
  max-width: 80px;
  margin-left: 10px;
}
@media only screen and (min-width: 1024px) {
  .song .btn-group-vertical {
    -ms-flex-direction: inherit;
    flex-direction: inherit;
    -ms-flex-align: inherit;
    align-items: inherit;
    -ms-flex-pack: inherit;
    justify-content: inherit;
  }
}
</style>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import axios from "axios";
  import moment from "moment";
  import { REST_ENDPOINT } from "@/constants";
  import SongCardButton from "@/components/SongCardButton";

  export default {
    components: {SongCardButton},
    props: {
      song: Object
    },
    data() {
      return {
        isDeleteSongRequested: false
      }
    },
    methods: {
      ...mapActions(['playSong','loadSongs']),
      humanizeDate(date) {
        return moment(date).format('ll');
      },
      deleteSong() {
        if (!this.isDeleteSongRequested)
        {
          this.isDeleteSongRequested = true;
          return;
        }

        axios.delete(`${REST_ENDPOINT}songs/${this.song.id}`)
          .then(() => { this.loadSongs().then(() => { 
            this.isDeleteSongRequested = false;
            document.activeElement.blur();
          })})
          .catch(error => {
            this.isDeleteSongRequested = false;
            console.error(error);
            this.showToast({
              title: "Échec de la suppression",
              text: "Une erreur est survenue lors de la suppression",
              type: 'error'
            });
          });
      },
      downloadFile (file, name) {
        axios.get(`${REST_ENDPOINT}/get_file.php?filename=${file}`, { responseType: 'blob' })
            .then(response => {
              const blob = new Blob([response.data], { type: file.endsWith('.pdf') ? 'application/pdf' : 'text/plain' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = `${name}.${file.split('.').pop()}`
              link.click()
              URL.revokeObjectURL(link.href)
            }).catch(console.error)
      },
      async copyTextInClipboard(text) {
        await navigator.clipboard.writeText(text);
      }
    },
    computed: {
      ...mapGetters(["isAdmin"])
    },
    inject: ['showToast']
  };
</script>
